import { render, staticRenderFns } from "./IndicadoresKPI.vue?vue&type=template&id=3be703ac&scoped=true&"
import script from "./IndicadoresKPI.vue?vue&type=script&lang=js&"
export * from "./IndicadoresKPI.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresKPI.vue?vue&type=style&index=0&id=3be703ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be703ac",
  null
  
)

export default component.exports